import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/core/services';
import {
	CopyrightComponent,
	LandingPageStaticComponent,
	QuickActionCardModel,
	QuickActionListComponent,
	TitleComponent,
} from '@app/shared/components';

@Component({
	selector: 'sb-home',
	standalone: true,
	imports: [TitleComponent, LandingPageStaticComponent, QuickActionListComponent, CopyrightComponent, NgIf],
	templateUrl: './home.component.html',
	styleUrl: './home.component.less',
})
export class SchoolBookkeepingHomeComponent implements OnInit {
	protected readonly title = 'Welcome to Bookkeeping';
	protected actionCards: QuickActionCardModel[];
	protected get hasActionCards() {
		return this.actionCards && this.actionCards.length > 0;
	}

	constructor(private readonly authService: AuthService) {}

	ngOnInit(): void {
		this.loadActionCards();
	}

	loadActionCards() {
		const cards: QuickActionCardModel[] = [
			{
				title: 'Payments Received',
				description: 'Add and review receipts',
				route: '/lsb/cash/receipts-mgmt',
			},
			{
				title: 'Vendor Payments',
				description: 'Add new vendor payments',
				route: '/lsb/cash/process-payments',
			},
		];

		if (this.authService.isAccessibleByLink('/lsb/manage-accounts/account-balances-quick-view') && !this.authService.authentication.isGA) {
			cards.push({
				title: 'Account Balances Quick View',
				description: 'View account balances',
				route: '/lsb/manage-accounts/account-balances-quick-view',
			});
		} else {
			cards.push({
				title: 'View Accounts',
				description: 'Review account information',
				route: '/lsb/reports/accountActivity',
			});
		}

		// Checking if the user has access to the route is only necessary because the list of action
		// cards is static, not set by user preferences.
		this.actionCards = cards.filter((card) => this.authService.isAccessibleByLink(card.route));
	}
}
